var frontDeskData = [
  {
    id: 0,
    title: 'Check out at 12.00 PM',
    dept: 'Front Desk',
    location: 9999,
    createdBY: 'Micheals',
    dueDate: 'Dec 12',
    status: 'Open',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum deserunt ullam iste! Recusandae dolore et repellat praesentium, magni nihil quibusdam!'
  },
  {
    id: 1,
    title: 'Check out at 12.30 PM',
    dept: 'Front Desk',
    location: 9999,
    createdBY: 'Micheals',
    dueDate: 'Dec 12',
    status: 'Not started',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum deserunt ullam iste! Recusandae dolore et repellat praesentium, magni nihil quibusdam!'
  },
  {
    id: 2,
    title: 'Check out at 1.00 PM',
    dept: 'Front Desk',
    location: 9999,
    createdBY: 'Micheals',
    dueDate: 'Dec 12',
    status: 'In progress',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum deserunt ullam iste! Recusandae dolore et repellat praesentium, magni nihil quibusdam!'
  },
  {
    id: 3,
    title: 'Guest checked out',
    dept: 'Front Desk',
    location: 9999,
    createdBY: 'Micheals',
    dueDate: 'Dec 12',
    status: 'Open',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum deserunt ullam iste! Recusandae dolore et repellat praesentium, magni nihil quibusdam!'
  },
  {
    id: 4,
    title: 'Early check in at 12:30 PM',
    dept: 'Front Desk',
    location: 9999,
    createdBY: 'Micheals',
    dueDate: 'Dec 12',
    status: 'In progress',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum deserunt ullam iste! Recusandae dolore et repellat praesentium, magni nihil quibusdam!'
  }
];
export default frontDeskData;
